import { allLanguages } from "@services/i18n-languages";
import { FilterChipDropdown, FilterOption } from "./filter-chip-dropdown";

/** Interface language options — keep in sync with ALLOWED_TRANSLATION_RESOURCES. */
const options: FilterOption<string>[] = [
  { value: "browser", i18n: "language_browser_default" },
  ...allLanguages
    .slice()
    .sort((a, b) => a.code.localeCompare(b.code))
    .map(
      (lang): FilterOption<string> => ({
        value: lang.code,
        noI18n: lang.name,
      }),
    ),
];

type InterfaceLanguageDropdownProps = {
  currentOption: string;
  onSelect: (val: string) => void;
  className?: string;
};
export function InterfaceLanguageDropdown({
  currentOption,
  onSelect,
  className,
}: InterfaceLanguageDropdownProps) {
  return (
    <FilterChipDropdown
      allOptions={options}
      currentOption={options.find(t => t.value === currentOption)}
      onSelect={onSelect}
      className={className}
    />
  );
}
